import { PostAPI } from 'Components/Helper/Helpers';

export const Select = async (request) => {
    return PostAPI(request, 'ICICIKYCPayoutController/Select');
};

export const Add = async (request) => {
    return PostAPI(request, 'ICICIKYCPayoutController/SenderRegistration');
}; 

export const VerifyOTP = async (request) => {
    return PostAPI(request, 'ICICIKYCPayoutController/SenderVerifyOTP');
};

export const ResendOTP = async (request) => {
    return PostAPI(request, 'ICICIKYCPayoutController/SenderResendOTP');
};

export const SelectBank = async (request) => {
    return PostAPI(request, 'DMTBank/Select');
};

export const AddBeneficiary = async (request) => {
    return PostAPI(request, 'PayoutBeneficiary/Add');
};

export const SelectBeneficiary = async (request) => {
    return PostAPI(request, 'PayoutBeneficiary/SelectBeneficiary');
};